import { priceChartType } from "../type";
import {
  getPriceChartApi,
  getLotListApi,
  getLotCodeInsertApi,
  insertPriceChartComponentApi,
  deletePriceChartComponentApi,
  updatePriceChartComponentApi,
  suggetionDataApi,
  bulkDataUpdateApi,
} from "../../api/pricingChart.api";


export const priceChartAction =
  (CustomerCode, Currency) => async (dispatch) => {
    try {
      const { data } = await getPriceChartApi({
        CustomerCode:CustomerCode.value,
        Currency,
      });

    
      dispatch({
        type: priceChartType.GET_PRICE_CHART,
        payload: {
          data: data.data,
          CustomerCode,
          Currency,
          // totalCount
        },
      });

      dispatch({
        type: priceChartType.ERROR_PRICE_CHART,
        payload: data.message,
      });
      // }
    } catch (error) {
      // console.log(error);

      dispatch({
        type: priceChartType.ERROR_PRICE_CHART,
        payload: error,
      });
    }
  };

export const lotCodeListAction = () => async (dispatch) => {
  try {
    const { data } = await getLotListApi();

    const lotCodeOpt = data.data.map((state) => ({
      label: state,
      value: state,
    }));

    dispatch({
      type: priceChartType.PRICE_CHART_LOTCODE_LIST,
      payload: {
        data: data.data,
        lotCodeOpt,
      },
    });
  } catch (error) {
    // console.log(error);

    dispatch({
      type: priceChartType.ERROR_PRICE_CHART,
      payload: error,
    });
  }
};

export const priceChartPagintationAction =
  (customerCode, Currency, ComponentDetailsName, page, limit, filterObject) =>
  async (dispatch) => {
    
    try {
      const { data } = await getPriceChartApi({
        CustomerCode: customerCode.value,
        Currency,
        ComponentDetailsName,
        page,
        limit,
        filterObject,
      });
      dispatch({
        type: priceChartType.PRIICNG_CHART_PAGINATION,
        payload: {
          rmNames: ComponentDetailsName,
          data: data.data,
        },
      });
    } catch (error) {
      // console.log(error);

      dispatch({
        type: priceChartType.ERROR_PRICE_CHART,
        payload: error,
      });
    }
  };

export const saveLotCodeAction =
  (component, priceChartId, rmNames, RM) => async (dispatch) => {
    try {
      let componentDet = {
        RM: component.RM,
        Commodity: component.Commodity,
        Shape: component.Shape,
        Color: component.Color,
        SieveSize: component.SieveSize,
        MMSize: component.MMSize,
        InternalQuality: component.InternalQuality,
        LotCode: component.Lotcode || component.LotCode || component.lotCode,
        SizeGroup: "",
        CustomerQuality: "",
        Clarity: "",
        MCP: component.MCP === "" || !component.MCP ? 0 : component.MCP,
        SalesPrice: component.SalesPrice,
        addByDMS: true,
        rmNames: component.rmNames,
      };

      const { data } = await insertPriceChartComponentApi({
        priceChartId,
        component: componentDet,
      });
   
      if (data.status === 200) {
        dispatch({
          type: priceChartType.PRIICNG_CHART_SINGLE_INSERT,
          payload: {
            data: data.data,
            rmNames: data.data.RM,
          },
        });
      }

      dispatch({
        type: priceChartType.ERROR_PRICE_CHART,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: priceChartType.ERROR_PRICE_CHART,
        payload: error,
      });
    }
  };

export const lotCodeInsertAction =
  (lotCode, rmNames, editDataHandle,SubareaId, rmId) => async (dispatch) => {
    // // console.log("🚀 ~ lotCode:", lotCode);
   
    try {
      const { data } = await getLotCodeInsertApi({ lotCode, SubareaId, rmId });
      // // console.log("🚀 ~ lotCodeInsertAction ~ data:", data.data);

      let {
        Color,
        Commodity,
        Lotcode,
        MCP,
        MMSize,
        RawMaterial,
        Shape,
        SieveSize,
        SalesPrice,
        InternalQuality,
      } = data.data;
      editDataHandle({
        MCP,
        SalesPrice,
        InternalQuality,
        MMSize,
        SieveSize,
        Color,
        Shape,
        Commodity,
      });

      dispatch({
        type: priceChartType.PRIICNG_CHART_COPY,
        payload: {
          Color,
          Commodity,
          lotCode,
          MCP,
          MMSize,
          RM: RawMaterial,
          SalesPrice,
          Shape,
          SieveSize: SieveSize,
          rmNames,
          addByDMS: true,
        },
      });
    } catch (error) {
      // console.log(error);

      dispatch({
        type: priceChartType.ERROR_PRICE_CHART,
        payload: error,
      });
    }
  };
 

export const priceChartComponentInsertAction =
  (priceChartId, lotCodesList, rmId, rmNames, SubareaId) => async (dispatch) => {
    
    try {
      const { data } = await insertPriceChartComponentApi({
        priceChartId,
        lotCodesList,
        rmId,
        SubareaId
      });
   
      if (data.status === 200) {
        dispatch({
          type: priceChartType.PRICING_CHART_INSERT,
          payload: {
            data: data.data.data,
            rmNames: rmNames,
            key: priceChartId,
            lotCodeSummary: data.data.summary,
          },
        });
      } else {
        dispatch({
          type: priceChartType.ERROR_PRICE_CHART,
          payload: data.message,
        });
      }
    } catch (error) {
      // console.log(error);

      dispatch({
        type: priceChartType.ERROR_PRICE_CHART,
        payload: error || "ERROR",
      });
    }
  };
 

export const priceChartComponentDeleteAction =
  (componentId, rmNames) => async (dispatch) => {
    try {
      const { data } = await deletePriceChartComponentApi({
        componentId: componentId,
      });

      dispatch({
        type: priceChartType.PRIICNG_CHART_DELETE,
        payload: { componentId: componentId, rmNames: rmNames },
      });
    } catch (error) {
      // console.log(error);

      dispatch({
        type: priceChartType.ERROR_PRICE_CHART,
        payload: error,
      });
    }
  };

export const priceChartComponentUpdateAction =
  (
    priceChartId,
    componentId,
    SalesPrice,
    MCP,
    rmNames,
    SieveSize,
    MMSize,
    InternalQuality
  ) =>
  async (dispatch) => {
    try {
      const { data } = await updatePriceChartComponentApi({
        priceChartId,
        componentId,
        SalesPrice,
        MCP,
        SieveSize,
        MMSize,
        InternalQuality,
      });

      dispatch({
        type: priceChartType.PRICING_CHART_UPDATE,
        payload: {
          priceChartId,
          componentId,
          SalesPrice,
          MCP,
          rmNames,
          SieveSize,
          MMSize,
          InternalQuality,
          ...data.data,
        },
      });
    } catch (error) {
      // console.log(error);

      dispatch({
        type: priceChartType.ERROR_PRICE_CHART,
        payload: error,
      });
    }
  };

export const suggectionDataAction =
  (RM, selectedCustomer, storedSubareaId, selectedTab, rmId) =>
  async (dispatch) => {
    try {
      const { data } = await suggetionDataApi({
        CustomerCode: selectedCustomer,
        RM,
        SubareaId: storedSubareaId,
        RawMaterialSuid: selectedTab,
        rmId,
      });

      const suggestionsObject = {};
      Object.keys(data.data).forEach((suggestionName) => {
        suggestionsObject[suggestionName] = data.data[suggestionName].map(
          (state) => ({
            label: state,
            value: state,
          })
        );
      });

      dispatch({
        type: priceChartType.PRIICNG_SUGGESSION_DATA,
        payload: suggestionsObject,
      });
    } catch (error) {
      // console.log(error);

      dispatch({
        type: priceChartType.ERROR_PRICE_CHART,
        payload: error,
      });
    }
  };

export const bulkDataUpdateExcelAction =
  (priceChartId, excelJson, rmId, rmNames, oldData) => async (dispatch) => {
  
    try {
      const { data } = await bulkDataUpdateApi({
        priceChartId,
        excelJson,
        rmId,
      });

      // Compare the fields in oldData and data.data.data to find missing fields
      const newData = data.data.data;

      const updatedData = oldData.map((item) => {
        const matchedItem = newData.find(
          (newItem) => newItem.lotCodeId === item._id
        );

        if (matchedItem) {
          // Merge the fields from matchedItem into item

          return {
            ...item,
            ...matchedItem,
          };
        }
        return item;
      });
  
     dispatch({
        type: priceChartType.PRIICNG_CHART_BULK_UPDATE_EXCEL,
        payload: { updatedData: updatedData, rmNames: rmNames },
      });
    } catch (error) {
      // console.log(error);

      dispatch({
        type: priceChartType.ERROR_PRICE_CHART,
        payload: error,
      });
    }
  };

export const loadingPriceChartAction =
  (toggle = true) =>
  (dispatch) => {
    dispatch({
      type: priceChartType.LOADING_PRICEING_CHART,
      payload: toggle,
    });
  };

export const toggleCopyRow = (isShowRowCopy) => (dispatch) => {
  dispatch({ type: priceChartType.TOGGLE_COPY_ROW, payload: isShowRowCopy });
};
